import { useMemo } from 'react';
import { useModal } from '@ebay/nice-modal-react';
import { ColumnDef } from '@tanstack/react-table';
import { Brain, Edit, Plus } from 'lucide-react';
import useDocuments from '@/hooks/useDocuments';
import { IDocument } from '@/types';
import DataTable from '../DataTable/DataTable';
import Section from '../Section';
import Time from '../Time';
import { Button } from '../ui/button';

function getByteLength(str: string) {
  const encoder = new TextEncoder();
  const utf8Bytes = encoder.encode(str);
  return utf8Bytes.length;
}

const Documents = () => {
  const documents = useDocuments();
  const drawer = useModal('document-drawer');
  const data = useMemo(() => documents.data || [], [documents.data]);

  const columns: ColumnDef<IDocument>[] = useMemo(
    () => [
      {
        accessorKey: 'name',
        header: 'Name',
      },
      {
        accessorKey: 'description',
        header: 'Description',
      },
      {
        accessorKey: 'body',
        header: 'Document Size',
        cell: ({ row }) => <>{getByteLength(row.original.body)} bytes</>,
      },
      {
        accessorKey: 'created_at',
        header: 'Created',
        cell: ({ row }) => <Time>{row.original.created_at}</Time>,
      },
      {
        accessorKey: 'updated_at',
        header: 'Updated',
        cell: ({ row }) => <Time>{row.original.updated_at}</Time>,
      },
      {
        accessorKey: 'internal_last_synced_at',
        header: 'Last Synced',
        cell: ({ row }) => <Time>{row.original.internal_last_synced_at}</Time>,
      },
      {
        header: 'Actions',
        cell: ({ row }) => (
          <Button
            onClick={() => {
              drawer.show({ document: row.original });
            }}
          >
            <Edit />
            Edit
          </Button>
        ),
      },
    ],
    [],
  );

  return (
    <>
      <div className="flex items-center justify-between gap-2 mb-8">
        <div className="flex items-center gap-2 mb-4 ">
          <Brain />
          <div className="text-lg font-bold">Documents</div>
        </div>
        <Button className="ml-auto" onClick={() => drawer.show()}>
          <Plus />
          Add Document
        </Button>
      </div>

      <Section>
        <DataTable data={data} columns={columns} model={documents} />
      </Section>
    </>
  );
};

export default Documents;
